export const getHeaders = (tabName) => {
  if (tabName.includes("verifiedTab")) {
    return [
      "salaryDisbursement.list.header.no",
      "salaryDisbursement.list.header.scheduledOn",
      "salaryDisbursement.list.header.employeeId",
      "salaryDisbursement.list.header.employeeName",
      "salaryDisbursement.list.header.grup",
      "salaryDisbursement.list.header.mobilePhoneNumber",
      "salaryDisbursement.list.header.BankName",
      "salaryDisbursement.list.header.accountNumber",
      "salaryDisbursement.list.header.nameOfAccountOwner",
      "salaryDisbursement.list.header.totalNominal",
      "salaryDisbursement.list.header.transferNews",
      "salaryDisbursement.list.header.companyEmail",
    ];
  }
  if (tabName.includes("rejectedTab")) {
    return [
      "salaryDisbursement.list.header.no",
      "salaryDisbursement.list.header.mobilePhoneNumber",
      "salaryDisbursement.list.header.accountNumber",
      "salaryDisbursement.list.header.totalNominal",
      "salaryDisbursement.list.header.transferNews",
      "salaryDisbursement.list.header.companyEmail",
      "salaryDisbursement.list.header.rejectionReason",
    ];
  }
  return [];
};

export const getFields = (tabName) => {
  if (tabName.includes("verifiedTab")) {
    return [
      "no",
      "expectedDisbursementDate",
      "employeeCode",
      "employeeName",
      "groupName",
      "phoneNumber",
      "bankName",
      "accountNumber",
      "beneficiaryName",
      "amount",
      "transactionNote",
      "email",
    ];
  }
  if (tabName.includes("rejectedTab")) {
    return [
      "no",
      "phoneNumber",
      "accountNumber",
      "amount",
      "transactionNote",
      "email",
      "staticErrorMessage",
    ];
  }
  return [];
};
